import * as apiService from "./v2/apiService";
import { baseURL } from "@/constants/v2/endPoints";

export const AGENT_SHOWCASE = "mine";

export const manageUrl = (id) =>
  id === AGENT_SHOWCASE ? `${baseURL}api/v2/showcase/mine` : `${baseURL}api/v2/brokerage/manage/${id}/showcase`;
const PUBLIC_URL = `${baseURL}api/v2/public/showcase`;

export const getShowcase = (id) => apiService.apiCall(manageUrl(id), "GET", {});

export const saveShowcaseItems = (id, items) => apiService.apiCall(`${manageUrl(id)}/items`, "PUT", { items });

export const saveShowcaseSettings = (id, settings) => apiService.apiCall(manageUrl(id), "PUT", settings);

export const addShowcaseSite = (id, host) => apiService.apiCall(`${manageUrl(id)}/sites`, "POST", { host });

export const removeShowcaseSite = (id, siteId) =>
  apiService.apiCall(`${manageUrl(id)}/sites/${siteId}`, "DELETE", {});

export const startShowcaseCheckout = (id, body = {}) => apiService.apiCall(`${manageUrl(id)}/checkout`, "POST", body);

export const updateShowcaseSite = (id, siteId, fields) =>
  apiService.apiCall(`${manageUrl(id)}/sites/${siteId}`, "PUT", fields);

export const detectShowcaseSite = (id, siteId) => apiService.apiCall(`${manageUrl(id)}/sites/${siteId}/detect`, "POST", {});

export const getShowcasePreview = (id, { look, layout, headline }) =>
  apiService.apiCall(`${manageUrl(id)}/preview`, "GET", {
    look: look || "",
    layout: layout || "",
    ...(headline ? { headline } : {}),
  });

export const confirmShowcaseCheckout = (id, sessionId) =>
  apiService.apiCall(`${manageUrl(id)}/checkout/confirm`, "POST", { sessionId });

export const openShowcasePortal = (id) => apiService.apiCall(`${manageUrl(id)}/portal`, "POST", {});

export const sendShowcaseGuide = (id, email) => apiService.apiCall(`${manageUrl(id)}/send-guide`, "POST", { email });

export const getPublicShowcase = (key, params) =>
  apiService.apiCallWithoutToken(`${PUBLIC_URL}/${encodeURIComponent(key)}`, "GET", params);

export const getPublicShowcaseBySlug = (slug, params, owner = "brokerage") =>
  apiService.apiCallWithoutToken(
    owner === "agent" ? `${PUBLIC_URL}/agent/${encodeURIComponent(slug)}` : `${PUBLIC_URL}/by-slug/${encodeURIComponent(slug)}`,
    "GET",
    params,
  );

export const getPublicShowcaseItem = (key, wantAdId) =>
  apiService.apiCallWithoutToken(`${PUBLIC_URL}/${encodeURIComponent(key)}/items/${wantAdId}`, "GET", {});
